export const isLoading = state => state.layoutLoadingCount > 0;

export const isEcarewave = (state, getters, rootstate) => rootstate.route.meta.isEcarewave;
